import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { rainSystemDefaultState } from './rain-system.constants';
import { MeasurementsAbstractComponent } from '../measurements-abastract.component';
import { FormEvent } from '../../../../common/shared/constants';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { RainSystemMeasurementsDto } from '../../../../../api/models/rain-system-measurements-dto';

@Component({
  selector: 'rain-system-measurements',
  templateUrl: './rain-system.component.html',
  styleUrls: ['./rain-system.component.scss'],
})
export class RainSystemComponent extends MeasurementsAbstractComponent implements OnInit, OnDestroy {
  @Output()
  eventEmitter = new EventEmitter<FormEvent<RainSystemMeasurementsDto>>();
  form!: UntypedFormGroup;

  @Input()
  initData: RainSystemMeasurementsDto | null = null;

  private garbageCollector: Subscription[] = [];

  constructor(private readonly _formBuilder: UntypedFormBuilder) {
    super();
  }
  ngOnInit(): void {
    let rainSystemVal = true;
    const rainSystem = this.initData ? this.initData : rainSystemDefaultState;
    const config: any = {
      groundToEavesHeight: new UntypedFormControl(rainSystem.groundToEavesHeight),
      eavesDescents: new UntypedFormControl(rainSystem.eavesDescents),
      rainSystem: new UntypedFormControl(rainSystem.rainSystem),
    };
    this.form = this._formBuilder.group(config);
    this.eventEmitter.emit({ value: this.form.value, valid: this.form.valid, unchanged: true });

    this.garbageCollector.push(
      this.form.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe((value) => {
        const formValue = { ...value };
        if (rainSystemVal !== formValue.rainSystem) {
          rainSystemVal = formValue.rainSystem;
          formValue.eavesDescents = 0;
          formValue.groundToEavesHeight = 0;
        }
        if (formValue.hasOwnProperty('groundToEavesHeight')) {
          formValue.groundToEavesHeight = Number(formValue.groundToEavesHeight);
        }
        this.eventEmitter.emit({ value: formValue, valid: this.form.valid });
      }),
    );
  }

  ngOnDestroy() {
    for (const subscription of this.garbageCollector) {
      subscription.unsubscribe();
    }
  }
}
